import Link from 'next/link'

export default function LinksSellAVehicle() {
    return (
        <ul>
            <li><Link href='/contact/sell'><a>Sell Us Your Vehicle</a></Link></li>
        </ul>
    )
}
